import { Event } from '@/app/event-stream';

export const HelpPopupOpenedEventName = 'help-popup-opened' as const;
export interface HelpPopupOpened {
    status: string;
}

export type HelpPopupOpenedEvent = Event<typeof HelpPopupOpenedEventName, HelpPopupOpened>;
